export default __webpack_public_path__ + "assets/76a692a588903d1276630cfa51c1db80.svg";